/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BabylonEpochListInfo } from '../models/BabylonEpochListInfo';
import type { BabylonEpochRequest } from '../models/BabylonEpochRequest';
import type { BabylonEpochSummaryInfo } from '../models/BabylonEpochSummaryInfo';
import type { CommonEmptyRequest } from '../models/CommonEmptyRequest';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class EpochControllerService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getEpochSummary({
        requestBody,
    }: {
        requestBody: CommonEmptyRequest,
    }): CancelablePromise<BabylonEpochSummaryInfo> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/epoch/summary',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getEpochList({
        requestBody,
    }: {
        requestBody: BabylonEpochRequest,
    }): CancelablePromise<BabylonEpochListInfo> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/epoch/list',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

}
